(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-config"] && !Shopify.designMode) return;
  try {
    
  class ProductConfigurator {
    static instances = new Map();

    static getInstance(container) {
      const existingInstance = ProductConfigurator.instances.get(container);
      if (existingInstance) {
        return existingInstance;
      }

      const newInstance = new ProductConfigurator(container);
      ProductConfigurator.instances.set(container, newInstance);
      return newInstance;
    }

    constructor(container) {
      this.container = container;
      this.externalId = container.closest('[data-external-id]').dataset.externalId;
      this.selections = {};

      this.init();
    }

    getSelections() {
      return this.getAllSelections();
    }

    async init() {
      if (!productDetail?.tags?.includes('web2print')) {
        return;
      }
      if (!this.externalId) {
        this.showError('No external ID found');
        return;
      }

      try {
        const productData = await this.fetchProductData();
        console.log('Product Data:', productData.data);
        this.render(productData?.data);
      } catch (error) {
        this.showError('Failed to load product configuration');
        console.error('Error:', error);
      }
    }

    async fetchProductData() {
      const apiUrl = `https://msc.personify.tech/api/products/${this.externalId}`;
      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    }

    render(data) {
      const configs = []; // data?.data?.configs
      // if (!configs.length) return;

      // Map each config to a section
      // let html = `
      //   <div class="container mb-heading">
      //     <h2 class="h4 section__heading">Customize your product</h2>
      //   </div>
      // `;

      // html += configs
      //   .map((config) => {
      //     if (config.type === 'select' && config.options) {
      //       return `
      //     <div class="container config-section">
      //       <div class="feature-header">
      //         <div class="feature-label-container">
      //           <span class="feature-label">
      //             <label class="feature-label-title">${config.title}</label>
      //           </span>
      //         </div>
      //       </div>

      //       <div class="section-container" style="padding-bottom: 8px">
      //         <div class="row">
      //           ${config.options
      //             .map(
      //               (option, index) => `
      //               <div class="gallery-item${index === 0 ? ' active' : ''}" data-option-value="${option.value}">
      //                 ${
      //                   option.image
      //                     ? `
      //                   <div class="picture-box">
      //                     <img
      //                       src="${option.image}"
      //                       class="img-fluid"
      //                       alt="${option.label}"
      //                     >
      //                   </div>
      //                 `
      //                     : ''
      //                 }
      //                 <div class="details">
      //                   <p>${option.label}</p>
      //                 </div>
      //               </div>
      //           `
      //             )
      //             .join('')}
      //         </div>
      //       </div>
      //     </div>
      //     `;
      //     }

      //     if (config.type === 'input') {
      //       return `
      //       <div class="container config-section">
      //         <div class="feature-header">
      //           <div class="feature-label-container">
      //             <span class="feature-label">
      //               <label class="feature-label-title">${config.title}</label>
      //             </span>
      //           </div>
      //         </div>
      //         <div class="section-container">
      //           <div class="input-container">
      //             <input
      //               type="text"
      //               placeholder="${config.placeholder || `Enter ${config.title.toLowerCase()}`}"
      //             >
      //           </div>
      //         </div>
      //       </div>
      //     `;
      //     }

      //     return '';
      //   })
      //   .join('\n');

      const html = `
        <div class="config-section">
          <h3 class="config-title">Generate print file</h3>
          <div class="action-cards-container">
            <div class="action-card">
              <span class="action-icon"><img src="https://cdn.shopify.com/s/files/1/0855/3162/3761/files/upload-icon.png?v=1732025534" alt="Upload" /></span>
              <span class="action-label">Upload Your File</span>
            </div>
            <div class="action-card">
              <span class="action-icon"><img src="https://cdn.shopify.com/s/files/1/0855/3162/3761/files/color-board-icon.png?v=1732025466" alt="Editor" /></span>
              <span class="action-label">Open Designer</span>
            </div>
            <div class="action-card">
              <span class="action-icon"><img src="https://cdn.shopify.com/s/files/1/0855/3162/3761/files/customise-icon.png?v=1732025495" alt="Customise" /></span>
              <span class="action-label">Custom a design</span>
            </div>
          </div>
        </div>
      `;
      this.container.querySelector('.configuration-container').innerHTML = html;
      this.attachEventListeners();
    }

    getAllSelections() {
      const selections = {};

      // Get all config sections
      const configSections = this.container.querySelectorAll('.config-section');

      configSections.forEach((section) => {
        const foundElm = section.querySelector('.feature-label-title');
        if (!foundElm) return;
        const title = foundElm.textContent;

        // Handle gallery/select type
        const activeItem = section.querySelector('.gallery-item.active');
        if (activeItem) {
          selections[title] = {
            value: activeItem.dataset.optionValue,
            label: activeItem.querySelector('.details p').textContent,
          };
        }

        // Handle input type
        const input = section.querySelector('input');
        if (input) {
          selections[title] = {
            value: input.value,
            type: 'input',
          };
        }
      });

      return selections;
    }

    attachEventListeners() {
      // Handle gallery item selection
      const galleryItems = this.container.querySelectorAll('.gallery-item');

      galleryItems.forEach((item) => {
        item.addEventListener('click', () => {
          // Remove active class from all items in the same section
          const gallery = item.closest('.config-section');
          gallery.querySelectorAll('.gallery-item').forEach((i) => i.classList.remove('active'));

          // Add active class to clicked item
          item.classList.add('active');

          // Trigger change event
          this.handleConfigurationChange();
        });
      });

      // Handle input changes
      const inputs = this.container.querySelectorAll('input');
      inputs.forEach((input) => {
        input.addEventListener('change', () => this.handleConfigurationChange());
      });

      this.selections = this.getAllSelections();
      window.productConfigSelections = this.selections;

      // Update button click handler to prevent card selection
      const packageButtons = this.container.querySelectorAll('.action-card button');
      packageButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation(); // Prevent card click
        });
      });

      // Handle action card clicks
      const actionCards = this.container.querySelectorAll('.action-card');
      actionCards.forEach((card, index) => {
        card.addEventListener('click', () => {
          const label = card.querySelector('.action-label').textContent.toLowerCase();
          if (label.includes('upload')) {
            this.handleUpload();
          } else if (label.includes('designer') || label.includes('custom')) {
            this.openDesigner();
          }
        });
      });
    }

    handleConfigurationChange() {
      // Update internal selections state
      this.selections = this.getAllSelections();
      window.productConfigSelections = this.selections;
      // Dispatch event (keeping this for compatibility)
      const event = new CustomEvent('configuration:changed', {
        detail: { selections: this.selections },
        bubbles: true,
      });
      this.container.dispatchEvent(event);
    }

    showError(message) {
      console.error(message);
    }

    openDesigner(artworkUrl) {
      const params = {};
      if (artworkUrl) {
        params.customArtwork = artworkUrl;
      }
      if (this.selections.size) {
        const sizeArr = this.selections.size.value.split('x');
        params.width = Number(sizeArr[0].trim()) * 10;
        params.height = Number(sizeArr[1].trim()) * 10;
      }
      window.showPrintManagerEditor(params);
    }

    generateCustomArtworkCode(length) {
      const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var text = '';

      for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      const date = new Date();
      return `${date.getMonth() + 1}${date.getDate()}` + text.toUpperCase();
    }

    async handleUpload() {
      // Create file input element
      const fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.accept = '.jpg,.jpeg,.png';
      fileInput.style.display = 'none';
      document.body.appendChild(fileInput);

      // Trigger file selection
      fileInput.click();

      // Handle file selection
      fileInput.addEventListener('change', async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        try {
          const name = this.generateCustomArtworkCode(5);
          const parts = file.name.split('.');
          const ext = parts[parts.length - 1];

          const res = await fetch('https://msc.personify.tech/api/users/me/get-upload-url', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              contentType: file.type,
              serverSidePath: `msc-custom-artwork/${name}.${ext}`,
            }),
          });
          const json = await res.json();
          const uploadAPIUrl = json.data;
          const res2 = await fetch(uploadAPIUrl, {
            method: 'PUT',
            headers: { 'Content-Type': file.type },
            body: file,
          });
          const uploadedUrl = `https://print-manager-media.s3.eu-west-1.amazonaws.com/msc-custom-artwork/${name}.${ext}`;
          console.log('uploadedUrl', uploadedUrl);
          // Clean up
          document.body.removeChild(fileInput);

          this.openDesigner(uploadedUrl);
        } catch (error) {
          console.error('Upload failed:', error);
        }
      });
    }
  }

  // Update the initialization to use getInstance
  document.addEventListener('DOMContentLoaded', function () {
    const containers = document.querySelectorAll('.product-configuration-main');
    containers.forEach((container) => ProductConfigurator.getInstance(container));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-substrate-config"]) return;
  try {
    
  class SubstrateConfigurator {
    static instances = new Map();

    static getInstance(container) {
      const existingInstance = SubstrateConfigurator.instances.get(container);
      if (existingInstance) {
        return existingInstance;
      }

      const newInstance = new SubstrateConfigurator(container);
      SubstrateConfigurator.instances.set(container, newInstance);
      return newInstance;
    }

    constructor(container) {
      this.container = container;
      this.selections = {};
      this.productData = window.productDetail;
      this.MATERIAL_OPTIONS = {
        foamex: {
          thickness: ['0.3', '0.5', '1'],
        },
        correx: {
          thickness: ['0.4', '1'],
        },
        dibondw: {
          thickness: ['0.3'],
        },
        dibonds: {
          thickness: ['0.3'],
        },
      };
      console.log('productData', this.productData);

      this.init();
    }

    openDesigner(artworkUrl) {
      const params = {};
      if (artworkUrl) {
        params.customArtwork = artworkUrl;
      }
      if (this.selections.size) {
        const sizeArr = this.selections.size.split('x');
        params.width = Number(sizeArr[0].trim()) * 10;
        params.height = Number(sizeArr[1].trim()) * 10;
      }
      window.showPrintManagerEditor(params);
    }

    init() {
      const staticConfig = {
        data: {
          configs: [
            {
              type: 'select',
              title: 'Material',
              options: [
                {
                  label: 'Foamex',
                  value: 'foamex',
                  image:
                    'https://print-manager-media.s3.eu-west-1.amazonaws.com/files/1731052352812-foamex%20image.png',
                },
                {
                  label: 'Correx',
                  value: 'correx',
                  image:
                    'https://print-manager-media.s3.eu-west-1.amazonaws.com/files/1731052370530-correx%20image.png',
                },
                {
                  label: 'Di-BOND (W)',
                  value: 'Di-BOND(W)',
                  image: 'https://print-manager-media.s3.eu-west-1.amazonaws.com/files/1731052383260-DiBond_white.png',
                },
                {
                  label: 'Di-BOND (S)',
                  value: 'Di-BOND(S)',
                  image:
                    'https://print-manager-media.s3.eu-west-1.amazonaws.com/files/1731052403432-DiBond_brushed.png',
                },
              ],
            },
            {
              type: 'select',
              title: 'Thickness',
              options: [], // Will be populated based on material selection
            },
            {
              type: 'select',
              title: 'Size',
              options: [
                { value: '10x10', label: '10 x 10' },
                { value: '50x70', label: '50 x 70' },
                { value: '100x70', label: '100 x 70' },
                { value: '100x140', label: '100 x 140' },
              ],
            },
            {
              type: 'select',
              title: 'Printing',
              options: [
                { label: 'Front', value: 'front' },
                { label: 'Different Front/Back', value: 'diff' },
                { label: 'Mirrored Front/Back', value: 'mirror' },
              ],
            },
            {
              type: 'select',
              title: 'Finish',
              options: [
                { label: 'Vanish', value: 'vanish' },
                { label: 'None', value: 'none' },
              ],
            },
            {
              type: 'action-cards',
              title: 'Generate print file',
              options: [
                {
                  label: 'Upload Your File',
                  value: 'upload',
                  icon: 'https://cdn.shopify.com/s/files/1/0855/3162/3761/files/upload-icon.png?v=1732025534',
                  action: () => this.handleUpload(),
                },
                {
                  label: 'Open Designer',
                  value: 'editor',
                  icon: 'https://cdn.shopify.com/s/files/1/0855/3162/3761/files/color-board-icon.png?v=1732025466',
                  action: () => this.openDesigner(),
                },
                {
                  label: 'Custom a design',
                  value: 'customise',
                  icon: 'https://cdn.shopify.com/s/files/1/0855/3162/3761/files/customise-icon.png?v=1732025495',
                  action: () => this.openDesigner(),
                },
              ],
            },
          ],
        },
      };

      this.render(staticConfig.data);
      this.setDefaultSelections(staticConfig.data);
    }

    updateSelectedVariant() {
      const selectedVariant = this.productData?.variants?.find((variant) => {
        const material = String(this.selections.material).toLowerCase();
        const size = String(this.selections.size).toLowerCase();
        const options = variant.options.map((option) => String(option).toLowerCase());
        return options.includes(material) && options.includes(size);
      });
      if (selectedVariant?.id) {
        this.selections.variantId = selectedVariant.id;
      }
    }

    generateCustomArtworkCode(length) {
      const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var text = '';

      for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      const date = new Date();
      return `${date.getMonth() + 1}${date.getDate()}` + text.toUpperCase();
    }

    setDefaultSelections(data) {
      data.configs.forEach((config) => {
        if (config.type === 'select' && config.options.length > 0) {
          const groupName = config.title.toLowerCase();
          const firstOption = config.options[0];
          const firstInput = this.container.querySelector(`input[name="${groupName}"][value="${firstOption.value}"]`);
          if (!!firstInput) {
            firstInput.checked = true;
            this.selections[groupName] = firstOption.value;
            this.updateSelection(groupName);

            if (groupName === 'material') {
              this.updateThicknessOptions();

              setTimeout(() => {
                const firstThickness = this.container.querySelector('input[name="thickness"]');
                if (firstThickness) {
                  firstThickness.checked = true;
                  this.selections['thickness'] = firstThickness.value;
                  this.updateSelection('thickness');
                }
              }, 0);
            }
          }
        }
      });
      // Initialize global window object with default selections
      this.updateSelectedVariant();
      window.productConfigSelections = this.selections;
    }

    render(data) {
      const configContainer = this.container.querySelector('.configuration-container');
      configContainer.innerHTML = '';

      data.configs.forEach((config) => {
        const section = document.createElement('div');
        section.className = 'config-section';

        const title = document.createElement('h3');
        title.className = 'config-title';
        title.textContent = config.title;
        section.appendChild(title);

        const optionsContainer = document.createElement('div');
        optionsContainer.className = config.type === 'action-cards' ? 'action-cards-container' : 'options-container';

        config.options.forEach((option) => {
          if (config.type === 'action-cards') {
            const card = this.createActionCard(option);
            optionsContainer.appendChild(card);
          } else {
            const optionElement = this.createOption(option, config.title.toLowerCase());
            optionsContainer.appendChild(optionElement);
          }
        });

        section.appendChild(optionsContainer);
        configContainer.appendChild(section);
      });
    }

    createOption(option, groupName) {
      const container = document.createElement('div');
      container.className = 'option-item';

      const input = document.createElement('input');
      input.type = 'radio';
      input.name = groupName;
      input.value = option.value;
      input.id = `${groupName}-${option.value}`;

      const label = document.createElement('label');
      label.htmlFor = input.id;

      if (option.image) {
        const image = document.createElement('img');
        image.src = option.image;
        image.alt = option.label;
        label.appendChild(image);
      }

      const text = document.createElement('span');
      text.textContent = option.label;
      label.appendChild(text);

      container.appendChild(input);
      container.appendChild(label);

      input.addEventListener('change', () => {
        this.selections[groupName] = option.value;
        this.updateSelection(groupName, container);

        if (groupName === 'material') {
          this.updateThicknessOptions();
        }
      });

      return container;
    }

    createActionCard(option) {
      const card = document.createElement('div');
      card.className = 'action-card';

      const icon = document.createElement('span');
      icon.className = 'action-icon';
      icon.innerHTML = `<img src="${option.icon}" alt="${option.label}" />`;

      const label = document.createElement('span');
      label.className = 'action-label';
      label.textContent = option.label;

      card.appendChild(icon);
      card.appendChild(label);

      card.addEventListener('click', option.action);

      return card;
    }

    updateSelection(groupName) {
      const containers = this.container.querySelectorAll(`input[name="${groupName}"]`);
      containers.forEach((input) => {
        const container = input.closest('.option-item');
        container.classList.toggle('selected', input.checked);
        
        if (input.checked) {
          // Update selections when an option is selected
          console.log('inputtt', input);
          this.selections[groupName] = input.value;
          // Update global window object with current selections
          this.updateSelectedVariant();
          window.productConfigSelections = this.selections;
        }
      });
    }

    updateThicknessOptions() {
      const selectedMaterial = this.selections['material'];
      if (!selectedMaterial) return;

      const thicknessOptions = this.MATERIAL_OPTIONS[selectedMaterial]?.thickness || [];
      const thicknessSection = this.container.querySelector('.config-section:nth-child(2)');
      const optionsContainer = thicknessSection.querySelector('.options-container');

      optionsContainer.innerHTML = '';

      thicknessOptions.forEach((thickness) => {
        const option = {
          label: thickness,
          value: thickness,
        };
        const optionElement = this.createOption(option, 'thickness');
        optionsContainer.appendChild(optionElement);
      });
    }

    handleDownload() {
      console.log('Download template', this.selections);
    }

    async handleUpload() {
      // Create file input element
      const fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.accept = '.jpg,.jpeg,.png';
      fileInput.style.display = 'none';
      document.body.appendChild(fileInput);

      // Trigger file selection
      fileInput.click();

      // Handle file selection
      fileInput.addEventListener('change', async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        try {
          // Here you can add your file upload logic
          // For example, sending to a server or processing the file
          const name = this.generateCustomArtworkCode(5);
          const parts = file.name.split('.');
          const ext = parts[parts.length - 1];

          const res = await fetch('https://msc.personify.tech/api/users/me/get-upload-url', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              contentType: file.type,
              serverSidePath: `msc-custom-artwork/${name}.${ext}`,
            }),
          });
          const json = await res.json();
          const uploadAPIUrl = json.data;
          const res2 = await fetch(uploadAPIUrl, {
            method: 'PUT',
            headers: { 'Content-Type': file.type },
            body: file,
          });
          const uploadedUrl = `https://print-manager-media.s3.eu-west-1.amazonaws.com/msc-custom-artwork/${name}.${ext}`;
          console.log('uploadedUrl', uploadedUrl);
          // Clean up
          document.body.removeChild(fileInput);

          this.openDesigner(uploadedUrl);
        } catch (error) {
          console.error('Upload failed:', error);
        } finally {
        }
      });
    }

    handleGetQuote() {
      console.log('Get quote', this.selections);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    const containers = document.querySelectorAll('.product-configuration-main');
    containers.forEach((container) => SubstrateConfigurator.getInstance(container));
  });

  } catch(e) { console.error(e); }
})();
})();
